import { ActionTree, MutationTree, GetterTree } from 'vuex'
import axios, { AxiosError } from 'axios'

import config from '../config'

export interface State {
    username: string,
    session: Session
}

export interface Session {
    jwt: string | undefined
    valid: boolean
}

export const mutations: MutationTree<State> = {
    setUsername(state, username: string) {
        state.username = username
    },
    setSession(state, session: Session) {
        state.session = {
            ...session,
            valid: true,
        }
    },
    clearSession(state) {
        state.session = {
            jwt: undefined,
            valid: false,
        }
    },
}

const state: State = {
    username: '',
    session: {
        jwt: undefined,
        valid: false,
    },
}

export const actions: ActionTree<State, any> = {
    async login(context, { password }) {
        const url = `${config.SERVER_URL}v1.0/auth/login/`
        const data = {
            username: context.state.username,
            password,
        }
        let response
        try {
            response = await axios.post(url, data)
        } catch (_e) {
            const e = _e as AxiosError
            if (e.response) {
                if (e.response.status === 400) {
                    throw Error('Invalid username or password')
                } else {
                    throw Error(`Server responded with an error: ${e.message}`)
                }
            } else {
                throw Error(e.message)
            }
        }
        context.commit('setSession', {
            jwt: response.data.token,
        })
    },
    async logout(context) {
        context.commit('clearSession')
    },
    async refresh(context) {
        const { jwt } = context.state.session
        if (!jwt) {
            return
        }
        const url = `${config.SERVER_URL}v1.0/auth/refresh/`
        const data = { token: jwt }
        let response
        try {
            response = await axios.post(url, data)
        } catch (e) {
            context.commit('clearSession')
            return
        }
        context.commit('setSession', {
            jwt: response.data.token,
        })
    },
}

export const auth = {
    namespaced: true,
    state,
    mutations,
    actions,
}



// WEBPACK FOOTER //
// ./src/store/auth.ts